import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APIService } from '../apiservices/apiservices';

type IResponse = {Item: any};
export type IRequestParamsAuditoria = {
  empresa?: string;
  contrato?: string;
  login?: string;
  email?: string;
  modulo?: string;
  origemAuditoria?: string;
  tituloAuditoria?: string;
  idatividade?: string;
  continuationToken?: string;
  desAcaoExecutada?: string;
  dataInicio?: string;
  dataFim?: string;
  parametroAcao?: string;
  tipoVisualizacaoLogs?: string;
  codigoItem?: string;
}

@Injectable()
export class AuditoriaProvider {
  private header=APIService.getHeader();

  constructor(public http: HttpClient) {
  }

  buscarRelatorios(guidRelatorio: string = null): Promise<{Item: any, erro: string}> {
    let me = this;
    me.header = APIService.getHeader();
    return new Promise((resolve, reject) => {

      let url = APIService.API_URL + 'auditoria';

      let params = {
        operacao: "buscar-relatorio"
      };

      if(guidRelatorio)
      {
        params['guidRelatorio'] = guidRelatorio;
      }

      this.http.post(url,{}, {headers:me.header, params})
        .subscribe({
          next: (response) => APIService.ApiCallbackTreatment.next(resolve, reject, response),
          error: (err) => APIService.ApiCallbackTreatment.error(resolve, reject, err),
        })
    });
  }

  gerarRelatorio(params: IRequestParamsAuditoria = {}): Promise<{Item: any, erro: string}> {

    let tmpParams = {...params};

    if(tmpParams['dataFim'])
    {
      let [date, time] = tmpParams['dataFim'].split("T");

      if(!time)
      {
        tmpParams['dataFim'] = `${date}T23:59:59`
      }
    }

    let me = this;
    me.header = APIService.getHeader();
    return new Promise((resolve, reject) => {

      let url = APIService.API_URL + 'auditoria';

      let paramsNotEmpty = {};

      Object.keys(tmpParams).forEach((key) => {
        if(tmpParams[key] !== null && tmpParams[key] !== undefined && params[key] !== "")
          paramsNotEmpty[key] = tmpParams[key];
      })

      paramsNotEmpty["operacao"] = "gerar-relatorio";

      this.http.post(url, {}, {headers:me.header, params: paramsNotEmpty})
        .subscribe({
          next: (response) => APIService.ApiCallbackTreatment.next(resolve, reject, response),
          error: (err) => APIService.ApiCallbackTreatment.error(resolve, reject, err),
        })
    });
  }

  get(params: IRequestParamsAuditoria = {}, rowsPerPage = 100): Promise<{Item: any, erro: string}> {

    let tmpParams = {...params};

    if(tmpParams['dataFim'])
    {
      let [date, time] = tmpParams['dataFim'].split("T");

      if(!time)
      {
        tmpParams['dataFim'] = `${date}T23:59:59`
      }
    }

    let me = this;
    me.header = APIService.getHeader();
    return new Promise((resolve, reject) => {

      let url = APIService.API_URL + 'auditoria';

      let paramsNotEmpty = {};

      Object.keys(tmpParams).forEach((key) => {
        if(tmpParams[key] !== null && tmpParams[key] !== undefined && params[key] !== "")
          paramsNotEmpty[key] = tmpParams[key];
      })

      paramsNotEmpty["rowsPerPage"] = rowsPerPage;

      this.http.get(url,{headers:me.header, params: paramsNotEmpty})
        .subscribe({
          next: (response) => APIService.ApiCallbackTreatment.next(resolve, reject, response),
          error: (err) => APIService.ApiCallbackTreatment.error(resolve, reject, err),
        })
    });
  }

  getParams(): Promise<{Item: any, erro: string}> {
    let me = this;
    me.header = APIService.getHeader();

    return new Promise((resolve, reject) => {

      let url = APIService.API_URL + 'auditoria?operacao=params';

      this.http.get(url,{headers:me.header})
        .subscribe({
          next: (response) => APIService.ApiCallbackTreatment.next(resolve, reject, response),
          error: (err) => APIService.ApiCallbackTreatment.error(resolve, reject, err),
        })
    });
  }



}
